import React from 'react';
import {Button, Menu, MenuItem, Position} from '@blueprintjs/core';
import {Popover2, Tooltip2} from "@blueprintjs/popover2";
import {IconNames} from '@blueprintjs/icons';

import {getDownloadUrl} from '../utils';

interface DownloadResultButtonProps {
  uid: string; // block uid
  result: any;
}

interface ContentMenuProps {
  uid: string;
  resultId: string;
}

const ContentMenu = React.memo(({uid, resultId}: ContentMenuProps) => {
  const csvUrl = getDownloadUrl(uid, resultId, 'csv');
  const xlsxUrl = getDownloadUrl(uid, resultId, 'xlsx');

  return (
    <Menu>
      <MenuItem
        text="CSV"
        target="_blank"
        href={csvUrl}
      />
      <MenuItem
        text="XLSX"
        target="_blank"
        href={xlsxUrl}
      />
    </Menu>
  )
});

const DownloadResultButton = ({
  uid,
  result,
}: DownloadResultButtonProps) => {
  if (!result) {
    return null;
  } else if (!result?.value?.data) {
    return null;
  }

  return (
    <Popover2
      content={
        <ContentMenu uid={uid} resultId={result.key}/>
      }
      position={Position.TOP_LEFT}
    >
      <Tooltip2
        hoverOpenDelay={1000}
        content="Download result"
      >
        <Button
          minimal={true}
          small={true}
          icon={IconNames.CLOUD_DOWNLOAD}
        />
      </Tooltip2>
    </Popover2>
  )
};

export default DownloadResultButton;
